import type { PerfilTanque } from '../../dominio/caminhaoTanque/perfil'

export function AcabamentoCarreta3D({ tanque }: { tanque: PerfilTanque }) {
  const frente = tanque.zCentroM + tanque.comprimentoM / 2
  const tras = tanque.zCentroM - tanque.comprimentoM / 2
  const fundo = tanque.alturaEixoM - tanque.alturaM / 2
  const lateral = tanque.larguraM / 2 + 0.03
  const traseira = tras - tanque.profundidadeTampoM - 0.28
  return (
    <group>
      <mesh position={[0, 0.95, frente + 1]} castShadow>
        <boxGeometry args={[0.95, 0.23, 2.7]} />
        <meshStandardMaterial color="#2e3b45" metalness={0.4} roughness={0.5} />
      </mesh>
      {[frente - 1.6, tras + 3.9].map((z) => (
        <mesh key={z} position={[0, fundo - 0.02, z]} castShadow>
          <boxGeometry args={[1.85, 0.22, 0.32]} />
          <meshStandardMaterial
            color="#4a5a65"
            metalness={0.5}
            roughness={0.45}
          />
        </mesh>
      ))}
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <mesh position={[lado * 0.9, 0.54, frente - 0.8]} castShadow>
            <boxGeometry args={[0.12, 0.64, 0.18]} />
            <meshStandardMaterial color="#35434d" metalness={0.4} />
          </mesh>
          <mesh position={[lado * 0.9, 0.21, frente - 0.8]}>
            <boxGeometry args={[0.3, 0.07, 0.35]} />
            <meshStandardMaterial color="#56656f" metalness={0.5} />
          </mesh>
          {[0.48, 0.73].map((y) => (
            <mesh key={y} position={[lado * lateral, y, tanque.zCentroM + 1.5]}>
              <boxGeometry args={[0.07, 0.08, 5]} />
              <meshStandardMaterial
                color="#8999a3"
                metalness={0.65}
                roughness={0.35}
              />
            </mesh>
          ))}
          {[-0.4, 1.7, 3.6].map((z) => (
            <mesh
              key={z}
              position={[lado * lateral, 0.67, tanque.zCentroM + z]}
            >
              <boxGeometry args={[0.08, 0.49, 0.06]} />
              <meshStandardMaterial color="#536571" metalness={0.5} />
            </mesh>
          ))}
          <mesh position={[lado * 1.02, 1.12, tras + 1.3]} castShadow>
            <boxGeometry args={[0.73, 0.12, 3.82]} />
            <meshStandardMaterial color="#35424d" roughness={0.65} />
          </mesh>
          <mesh position={[lado * 1.03, 0.59, tras - 0.52]}>
            <boxGeometry args={[0.62, 0.81, 0.04]} />
            <meshStandardMaterial color="#29333a" roughness={0.9} />
          </mesh>
          {Array.from({ length: 8 }, (_, i) => (
            <mesh
              key={i}
              position={[
                lado * (lateral + 0.04),
                0.77,
                frente - 0.25 - i * 1.12,
              ]}
            >
              <boxGeometry args={[0.022, 0.06, 0.38]} />
              <meshStandardMaterial
                color={i % 2 ? '#b44039' : '#dde8e6'}
                roughness={0.45}
              />
            </mesh>
          ))}
          {[frente - 0.45, tanque.zCentroM, tras + 0.3].map((z) => (
            <mesh key={z} position={[lado * (lateral + 0.05), 0.9, z]}>
              <boxGeometry args={[0.025, 0.055, 0.12]} />
              <meshStandardMaterial color="#d99631" roughness={0.3} />
            </mesh>
          ))}
          <mesh position={[lado * 0.86, 0.62, traseira]}>
            <boxGeometry args={[0.59, 0.22, 0.06]} />
            <meshStandardMaterial color="#29333b" />
          </mesh>
          {[-0.18, 0, 0.18].map((x, i) => (
            <mesh key={x} position={[lado * 0.86 + x, 0.64, traseira - 0.04]}>
              <boxGeometry args={[0.13, 0.12, 0.026]} />
              <meshStandardMaterial
                color={i === 0 ? '#db9945' : '#c74542'}
                roughness={0.24}
              />
            </mesh>
          ))}
        </group>
      ))}
      {Array.from({ length: 6 }, (_, i) => (
        <mesh key={i} position={[-0.94 + i * 0.38, 0.57, traseira - 0.14]}>
          <boxGeometry args={[0.31, 0.055, 0.025]} />
          <meshStandardMaterial
            color={i % 2 ? '#c5473e' : '#e3e8e5'}
            roughness={0.35}
          />
        </mesh>
      ))}
      {tanque.secao === 'eliptica' && (
        <group>
          {[-0.42, 0.42].map((x) => (
            <mesh
              key={x}
              position={[
                x,
                tanque.alturaEixoM + tanque.alturaM / 2 + 0.39,
                tanque.zCentroM,
              ]}
            >
              <boxGeometry args={[0.035, 0.035, tanque.comprimentoM * 0.91]} />
              <meshStandardMaterial color="#80919c" metalness={0.65} />
            </mesh>
          ))}
          {[-0.42, 0.42].flatMap((x) =>
            [-3.6, 0, 3.6].map((z) => (
              <mesh
                key={`${x}-${z}`}
                position={[
                  x,
                  tanque.alturaEixoM + tanque.alturaM / 2 + 0.21,
                  tanque.zCentroM + z,
                ]}
              >
                <boxGeometry args={[0.035, 0.4, 0.035]} />
                <meshStandardMaterial color="#80919c" metalness={0.65} />
              </mesh>
            )),
          )}
          {[-0.31, 0.31].map((x) => (
            <mesh key={x} position={[x, tanque.alturaEixoM, traseira + 0.1]}>
              <boxGeometry args={[0.04, tanque.alturaM + 0.7, 0.04]} />
              <meshStandardMaterial color="#6b7d8a" metalness={0.65} />
            </mesh>
          ))}
          {Array.from({ length: 7 }, (_, i) => (
            <mesh
              key={i}
              position={[
                0,
                tanque.alturaEixoM - tanque.alturaM / 2 + i * 0.35,
                traseira + 0.1,
              ]}
            >
              <boxGeometry args={[0.64, 0.035, 0.035]} />
              <meshStandardMaterial color="#9aaab4" metalness={0.65} />
            </mesh>
          ))}
        </group>
      )}
    </group>
  )
}
